module.exports = __webpack_public_path__ + "img/86048819.1245fd74.png";